import React from "react";
import RichText from "blocks/rich-text";

const Text = ({ richText }) => {
  return <RichText richText={richText} />;
};

export default Text;
